module.exports = {
  sanity: {
    projectId: process.env.SANITY_PROJECT_ID || 'ilzvddob',
    dataset: process.env.SANITY_DATASET || 'production',
  },
};
